import React, { type ComponentType } from 'react';
import get from 'lodash/get';
import { FireScreenAnalytics as FireScreenAnalyticsDI } from '@atlassian/jira-product-analytics-bridge';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import type { ProjectConfigData } from '../../common/types';
import ProjectConfigQueryDI, {
	type Props as ProjectConfigQueryProps,
} from '../../common/utils/project-config-query';

export type Props = {
	boardId: number;
};

type InternalProps = Props & {
	ProjectConfigQuery: ComponentType<ProjectConfigQueryProps>;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	FireScreenAnalytics: ComponentType<any>;
};

const ViewEvent = ({ boardId, ProjectConfigQuery, FireScreenAnalytics }: InternalProps) => {
	const tenantContext = useTenantContext();

	return (
		<ProjectConfigQuery variables={{ boardId }}>
			{/* @ts-expect-error - TS7031 - Binding element 'projectConfigData' implicitly has an 'any' type. | TS7031 - Binding element 'projectConfigLoading' implicitly has an 'any' type. */}
			{({ data: projectConfigData, loading: projectConfigLoading }) => {
				const features: ProjectConfigData | null = get(
					projectConfigData,
					['boardScope', 'features'],
					null,
				);
				const featureMapping: {
					[key: string]: string;
				} | null =
					features &&
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					features.reduce<Record<string, any>>((acc, val) => {
						acc[val.key] = val.status;
						return acc;
					}, {});

				return (
					!projectConfigLoading &&
					featureMapping && (
						<FireScreenAnalytics
							attributes={{
								...featureMapping,
								isJiraAdmin: tenantContext.isAdmin,
								isSiteAdmin: tenantContext.isSiteAdmin,
							}}
						/>
					)
				);
			}}
		</ProjectConfigQuery>
	);
};

ViewEvent.defaultProps = {
	ProjectConfigQuery: ProjectConfigQueryDI,
	FireScreenAnalytics: FireScreenAnalyticsDI,
};

export default ViewEvent;
